export const FETCH_NEXT_POST_STARTED = "FETCH_NEXT_POST_STARTED";
export const FETCH_NEXT_POST_SUCCESS = "FETCH_NEXT_POST_SUCCESS";
export const FETCH_NEXT_POST_FAILURE = "FETCH_NEXT_POST_FAILURE";
export const SHOW_PREVIOUS_POST = "SHOW_PREVIOUS_POST";
export const SHOW_CURRENT_POST = "SHOW_CURRENT_POST";
export const SHOW_NEXT_POST = "SHOW_NEXT_POST";
export const SHOW_NEXT_SUBPOST = "SHOW_NEXT_SUBPOST";
export const SHOW_PREVIOUS_SUBPOST = "SHOW_PREVIOUS_SUBPOST";
export const CHECK_IF_SUBREDDIT_IS_OK = "CHECK_IF_SUBREDDIT_IS_OK";
export const CHECK_IF_SUBREDDIT_IS_OK_STARTED =
  "CHECK_IF_SUBREDDIT_IS_OK_STARTED";
export const CHECK_IF_SUBREDDIT_IS_OK_FAILURE =
  "CHECK_IF_SUBREDDIT_IS_OK_FAILURE";
export const CHECK_IF_SUBREDDIT_IS_OK_SUCCESS =
  "CHECK_IF_SUBREDDIT_IS_OK_SUCCESS";
export const CHANGE_SUBREDDIT = "CHANGE_SUBREDDIT";
export const CHANGE_SEARCH_TERM = "CHANGE_SEARCH_TERM";
export const GET_LIST_OF_SUBREDDITS = "GET_LIST_OF_SUBREDDITS";
export const GET_LIST_OF_SUBREDDITS_STARTED = "GET_LIST_OF_SUBREDDITS_STARTED";
export const GET_LIST_OF_SUBREDDITS_FAILURE = "GET_LIST_OF_SUBREDDITS_FAILURE";
export const GET_LIST_OF_SUBREDDITS_SUCCESS = "GET_LIST_OF_SUBREDDITS_SUCCESS";
export const UPDATE_SEARCH_RESULTS = "UPDATE_SEARCH_RESULTS";
export const HIDE_SEARCH_RESULTS = "HIDE_SEARCH_RESULTS";
export const SHOW_SEARCH_RESULTS = "SHOW_SEARCH_RESULTS";
export const UPDATE_CURRENT_SUBREDDIT_AFTER = "UPDATE_CURRENT_SUBREDDIT_AFTER";
export const CHANGE_VISIBILITY = "CHANGE_VISIBILITY";
export const CHANGE_PRELOAD_AFTER = "CHANGE_PRELOAD_AFTER";
export const UPDATE_PRELOADED = "UPDATE_PRELOADED";
export const CHANGE_SORT = "CHANGE_SORT";
export const SHOW_SEARCH_PANEL = "SHOW_SEARCH_PANEL";
export const HIDE_SEARCH_PANEL = "HIDE_SEARCH_PANEL";
export const SHOW_SETTINGS_PANEL = "SHOW_SETTINGS_PANEL";
export const HIDE_SETTINGS_PANEL = "HIDE_SETTINGS_PANEL";
